export const cmsModule = {
  feedGoodsGoDetail: 'n.4106.6940.0', // feed商品去详情
  feedAddGoods: 'n.4106.8262.0', // feed加购商品
  feedSubscribeGoods: 'n.4106.8263.0', // feed订阅商品(到货提醒)
  feedGoPop: 'n.4106.240.0' // feed订阅商品(到货提醒)
}
